if (!customElements.get("product-friends-slider")) {
  class ProductFriendsSlider extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const modal = this.closest("modal-dialog");

      this.slider = new Swiper(this, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 24,
        watchOverflow: true,
        keyboard: { enabled: true },
        navigation: {
          prevEl: modal?.querySelector(".swiper-button--prev"),
          nextEl: modal?.querySelector(".swiper-button--next")
        },
        on: {
          activeIndexChange: swiper => {
            const counter = modal?.querySelector(
              "[data-friends-media-counter-index]"
            );
            if (counter) counter.textContent = swiper.activeIndex + 1;
          }
        }
      });
    }

    slideToIndex(index) {
      if (!this.slider) return;
      this.slider.update();
      this.slider.slideTo(index, 0);
    }
  }

  customElements.define("product-friends-slider", ProductFriendsSlider);
}

if (!customElements.get("product-friends-strip")) {
  class ProductFriendsStrip extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", this.onThumbClick.bind(this));
    }

    onThumbClick(event) {
      const thumb = event.target.closest("[data-friends-index]");
      if (!thumb) return;

      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (!modal) return;

      modal.show(thumb);

      const slider = modal.querySelector("product-friends-slider");
      // Sizes are only measurable once the modal is visible.
      requestAnimationFrame(() =>
        slider?.slideToIndex(Number(thumb.dataset.friendsIndex) || 0)
      );
    }
  }

  customElements.define("product-friends-strip", ProductFriendsStrip);
}
